<template>
  <div class="portfolio">
    <AppNavigation />
    <main>
      <MastheadSection />
      <ReadoutStrip />
      <ExperienceSection />
      <StageSection
        v-for="(p, i) in stages"
        :key="p.id"
        :project="p"
        :index="i"
      />
      <LedgerSection :projects="projects" />
      <ProfileSection />
      <ContactSection />
    </main>
    <AppFooter />
    <MobileBar />
  </div>
</template>

<script>
import { computed } from "vue";
import AppNavigation from "@/components/common/AppNavigation.vue";
import AppFooter from "@/components/common/AppFooter.vue";
import MobileBar from "@/components/common/MobileBar.vue";
import MastheadSection from "@/components/sections/MastheadSection.vue";
import ReadoutStrip from "@/components/sections/ReadoutStrip.vue";
import ExperienceSection from "@/components/sections/ExperienceSection.vue";
import StageSection from "@/components/sections/StageSection.vue";
import LedgerSection from "@/components/sections/LedgerSection.vue";
import ProfileSection from "@/components/sections/ProfileSection.vue";
import ContactSection from "@/components/sections/ContactSection.vue";
import projectsData from "@/data/projects.json";

export default {
  name: "HomeView",
  components: {
    AppNavigation,
    AppFooter,
    MobileBar,
    MastheadSection,
    ReadoutStrip,
    ExperienceSection,
    StageSection,
    LedgerSection,
    ProfileSection,
    ContactSection,
  },
  setup() {
    const projects = computed(() =>
      projectsData.filter((p) => p.active !== false)
    );

    // Which projects get a full-width stage is data, not markup: set
    // "stage": n on a project with a real capture and it appears here.
    const stages = computed(() =>
      projects.value
        .filter((p) => p.stage)
        .sort((a, b) => a.stage - b.stage)
    );

    return { projects, stages };
  },
};
</script>
